import config from './config';
import createApplication from './app';

const run = createApplication(config);
run();



// WEBPACK FOOTER //
// ./src/index.jsx